import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Dialog,
  Message,
  Card,
  Pagination,
  Icon,
} from '@alifd/next';
import moment from 'moment';
import { history } from 'ice';
import Swal from 'sweetalert2';
import { Image } from 'antd';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';
import axios from 'axios';

const Vote = () => {
  const vote = client.service('vote');
  const [voteArr, setVoteArr] = useState([]);
  const [voteViewDialog, setVoteViewDialog] = useState(false);
  const [currentVote, setCurrentVote] = useState({});

  // sort
  const [curDataIndex, setcurDataIndex] = useState('order');
  const [curOrder, setcurOrder] = useState('desc');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = voteArr.slice(indexOfFirstPost, indexOfLastPost);

  async function funFind(para) {
    const result = await vote.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funUpdate(id, obj) {
    await vote.update(id, obj);
  }
  async function funRemove(id) {
    await vote.remove(id);
  }

  const serverDataUpdate = (dataIndex, order) => {
    const rDataIndex = dataIndex || curDataIndex;
    const rOrder = order || curOrder;

    funFind({}).then((result) => {
      setVoteArr(
        result.sort((a, b) => {
          const result = (
            typeof a[rDataIndex] === 'number' || 'boolean'
              ? a[rDataIndex].toString()
              : a[rDataIndex]
          ).localeCompare(
            typeof b[rDataIndex] === 'number' || 'boolean'
              ? b[rDataIndex].toString()
              : b[rDataIndex]
          );
          return rOrder === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    serverDataUpdate();
  }, []);

  // 刪除功能
  const removeItem = async () => {
    const result = await funFind({});
    const prePages = currentPage - 1 >= 0 ? currentPage - 1 : 0;
    if (voteArr.length - 1 <= prePages * postsPerPage) {
      setCurrentPage(currentPage - 1 < 1 ? 1 : currentPage - 1);
    }
    for (let i = 0; i < result.length; i++) {
      result[i].order = result.length - i - 1;
      await funUpdate(result[i]._id, result[i]);
    }
    setVoteArr(result);
  };

  useEffect(() => {
    if (
      voteViewDialog &&
      currentVote._id &&
      currentVote.showUserName === 'true'
    ) {
      console.log({ currentVote });
      (async () => {
        const res = await axios.post(
          '/ezcon/api/postMongoAggregate',
          {
            service: 'voteResult',
            aggregate: [
              {
                $addFields: {
                  voteId: {
                    $toString: '$voteId',
                  },
                },
              },
              {
                $match: {
                  voteId: `${currentVote._id}`,
                },
              },
              {
                $lookup: {
                  from: 'users',
                  localField: 'voter_Id',
                  foreignField: '_id',
                  as: 'voter',
                },
              },
              {
                $unwind: {
                  path: '$voter',
                },
              },
              {
                $unwind: {
                  path: '$options',
                },
              },
              {
                $group: {
                  _id: '$options.id',
                  users: {
                    $push: '$voter.name',
                  },
                },
              },
            ],
          },
          {
            headers: {
              authorization: localStorage.getItem('feathers-jwt'),
            },
          }
        );
        console.log({ res });
        setCurrentVote((prev) => ({ ...prev, voteResult: res.data }));
      })();
    }
  }, [voteViewDialog, currentVote._id]);

  console.log({ currentVote });

  return (
    <>
      <Button
        className={styles.buttonAdd}
        onClick={() => {
          Message.success('準備跳轉請稍候...');
          setTimeout(() => {
            history.push('/ezpro/vote/voteAdd');
          }, 1000);
        }}
      >
        <Icon type="add" />
        發起投票
      </Button>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={voteViewDialog}
        onOk={() => {
          setVoteViewDialog(false);
        }}
        onCancel={() => {
          setVoteViewDialog(false);
        }}
        onClose={() => {
          setVoteViewDialog(false);
        }}
      >
        <h3>投票預覽</h3>

        <Card free>
          <Card.Header
            title={`議題:${currentVote?.title || ''}`}
            subTitle={currentVote?.top === 'true' ? '重要事項' : ''}
          />
          <Card.Content>
            <h3>
              開始日期:
              <span className={styles.spanText}>
                {currentVote.buildTime &&
                  moment(parseInt(currentVote.buildTime, 10)).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
              </span>
            </h3>
            <h3>
              結束日期:
              <span className={styles.spanText}>
                {currentVote.endTime &&
                  moment(parseInt(currentVote.endTime, 10)).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
              </span>
            </h3>
            <h3>
              內容:
              <span className={styles.spanText}>
                {currentVote?.content || ''}
              </span>
            </h3>
            <h3>
              當前投票人數:
              <span className={styles.spanText}>
                {currentVote?.voters || ''}
              </span>
            </h3>
            <h3>
              投票限制:
              <span className={styles.spanText}>
                {currentVote?.voteType === '0' ? '一戶一票' : '一人一票'}
              </span>
            </h3>
            <h3>
              選項複選:
              <span className={styles.spanText}>
                {currentVote?.optionCheck === 'true' ? '是' : '否'}
              </span>
            </h3>
            <h3>
              投票記名:
              <span className={styles.spanText}>
                {currentVote?.showUserName === 'true' ? '是' : '否'}
              </span>
            </h3>
            <h3>
              修改投出結果:
              <span className={styles.spanText}>
                {currentVote?.reSubmittable === 'true' ? '是' : '否'}
              </span>
            </h3>
            {(currentVote?.files || [])[0] !== '' ? (
              <>
                <h3>附加圖片:</h3>
                {(currentVote?.files || []).map((list, index) => {
                  return (
                    <div key={index}>
                      <Image className={styles.photo} src={list} alt="圖片" />
                    </div>
                  );
                })}
              </>
            ) : null}

            <div>
              <h3>投票選項:</h3>
              {currentVote.showUserName === 'false' &&
                (currentVote?.options || []).map((list, index) => {
                  return (
                    <ul key={index}>
                      <li className={styles.optionList}>
                        {`選項${list.id}`}
                        <span>{list.title}</span>
                        <span>{list.vote}票</span>
                      </li>
                    </ul>
                  );
                })}
              {currentVote.showUserName === 'true' && (
                <div>
                  {(currentVote?.voteResult || []).map((option, oIndex) => (
                    <div key={oIndex}>
                      <h3>
                        {currentVote?.options.find(
                          (o) => o.id === Number(option._id)
                        )?.title || ''}
                      </h3>
                      <p>
                        {(option?.users || []).map((user, uIndex, arr) => (
                          <span key={uIndex}>{`${user}${
                            uIndex !== arr.length - 1 ? ',' : ''
                          } `}</span>
                        ))}
                      </p>
                      <p>共{option?.users?.length || 0}票</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Card.Content>
        </Card>
      </Dialog>

      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            <Table.Column sortable title="標題" dataIndex="title" width={300} />
            <Table.Column
              sortable
              title="投票限制"
              width={100}
              dataIndex="voteType"
              cell={(val) => <p>{val === '0' ? '一戶一票' : '一人一票'}</p>}
            />
            <Table.Column
              title="投票時間"
              width={150}
              cell={(_val, _index, record) => {
                return (
                  <div>
                    <p>
                      {moment(parseInt(record.buildTime, 10)).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )}
                    </p>
                    <p>至</p>
                    <p>
                      {moment(parseInt(record.endTime, 10)).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )}
                    </p>
                  </div>
                );
              }}
            />
            <Table.Column
              title="投票人數"
              dataIndex="voters"
              width={100}
              sortable
            />
            <Table.Column
              sortable
              dataIndex="status"
              title="狀態"
              width={100}
              cell={(val) => <p>{val === true ? '開啟' : '關閉'}</p>}
            />
            <Table.Column
              title="操作"
              width={150}
              lock="right"
              cell={(_val, _index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="primary"
                      onClick={() => {
                        console.log({ record });
                        setVoteViewDialog(true);
                        setCurrentVote(record);
                      }}
                    >
                      查看
                    </Button>

                    <Button
                      style={{ marginLeft: '10px' }}
                      type="primary"
                      warning
                      onClick={() => {
                        const item = record;

                        Swal.fire({
                          title: `確定刪除標題(${record.title})資料?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此筆資料已刪除', 'success');
                            funRemove(item._id).then(() => {
                              removeItem();
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>

          <Pagination
            className={styles.pagination}
            total={voteArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default Vote;
